export default __webpack_public_path__ + "static/media/1805.9420c8ab.png";